import {
    CONSULTAR_PERIODOS_MORA,
    PERIODOS_MORA_CONSULTADOS,
    ERROR_CONSULTANDO_PERIODOS,
    DESCARGAR_XLS_PERIODOS_MORA,
    XLS_REPORTE_MORA_CREADO,
    periodosConsultados,
    errorConsultandoPeriodos,
    XLSReporteMoraCreado
} from "./periodosMoraActions";
import {
    cabeceraReporteMoraSAT,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroPeriodosMora, PeriodoMora } from "../modelo/AdminPeriodosMora";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import fileDownload from "js-file-download";
import * as moment from "moment";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarPeriodosMoraEpic = action$ =>
    action$.ofType(CONSULTAR_PERIODOS_MORA)
        .mergeMap((action: any) => {

            const url = `sat/consultar/periodos-mora?${obtenerFiltroPeriodos(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return periodosConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoPeriodos()];
                });
        });

export const descargarXLSPeriodosMoraEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_PERIODOS_MORA)
        .mergeMap((action: any) => {

            const url = `sat/consultar/periodos-mora?${obtenerFiltroPeriodos(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    const excelBlob: Blob = construirXLS(respuesta.datosEntidad);
                    const nombreArchivo = `reporte_mora_sat_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                    fileDownload(
                        excelBlob,
                        nombreArchivo,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return XLSReporteMoraCreado();
                });
        });

export const periodosMoraReducer = (state = {
    estado: REQUEST.NONE,
    periodos: [],
    paginas: 0,
    totalPeriodosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_PERIODOS_MORA:
            return {
                ...state,
                estado: REQUEST.PENDING,
                periodos: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalPeriodosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case PERIODOS_MORA_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                periodos: action.datosEntidad,
                paginas: action.paginas,
                totalPeriodosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_PERIODOS:
            return {
                ...state,
                estado: REQUEST.ERROR,
                periodos: [],
                paginas: 0,
                totalPeriodosConsulta: 0,
                showAlert: false
            };
        case DESCARGAR_XLS_PERIODOS_MORA:
        case XLS_REPORTE_MORA_CREADO:
            return {
                ...state
            };
        default:
            return state;
    }
};

const obtenerFiltroPeriodos = (filtro: FiltroPeriodosMora) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.numeroPoliza) params.set('numeroPoliza', filtro.numeroPoliza);
        if (filtro.tipoDocumento) params.set('tipoDocumento', filtro.tipoDocumento);
        if (filtro.documento) params.set('documento', filtro.documento);
        if (filtro.consecutivoNIT) params.set('consecutivoNIT', filtro.consecutivoNIT.toString());
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');
    }

    return params.toString();
};

const construirXLS = (datos: Array<PeriodoMora>) => {
    if (!datos || !datos.length)
        return;
    /*Libros a generar en el XLS*/
    const libro = 'Reporte Mora SAT';
    const librosXLS = [libro];

    const datosPeriodos = [];

    datos.forEach(periodo => {
        datosPeriodos.push([
            { value: periodo.aseguradora },
            { value: periodo.tipoDocumento },
            { value: periodo.numeroDocumento },
            { value: periodo.consecutivoNIT },
            { value: periodo.periodoMora }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libro,
        cabecera: cabeceraReporteMoraSAT(),
        datos: datosPeriodos,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/periodos_mora/modulos/periodosMoraReducers.ts